import { useCustomEvent } from '@sloyd/ui';
import { useList } from 'react-use';
import styled from 'styled-components';

export function Logs() {
  const [logs, { push }] = useList();

  useCustomEvent('realtime', (data) => {
    push(data);
  });

  return (
    <Wrapper>
      <h1>Logs</h1>
      <div>
        {logs.map((log, index) => (
          <div key={index}>{JSON.stringify(log)}</div>
        ))}
      </div>
    </Wrapper>
  );
}

export const Wrapper = styled.div`
  position: fixed;
  top: 100px;
  left: 100px;
  width: 500px;
  height: 500px;
  border: 1px solid green;
  z-index: 999;
  background-color: #334;
`;
